__turbopack_context__.v({
  "backgroundLayer": "RingProHero-module__SqReqG__backgroundLayer",
  "body": "RingProHero-module__SqReqG__body",
  "bottomFade": "RingProHero-module__SqReqG__bottomFade",
  "campaignAbove": "RingProHero-module__SqReqG__campaignAbove",
  "content": "RingProHero-module__SqReqG__content",
  "copy": "RingProHero-module__SqReqG__copy",
  "copyReveal": "RingProHero-module__SqReqG__copyReveal",
  "cta": "RingProHero-module__SqReqG__cta",
  "ctaGlass": "RingProHero-module__SqReqG__ctaGlass",
  "ctaRow": "RingProHero-module__SqReqG__ctaRow",
  "eyebrow": "RingProHero-module__SqReqG__eyebrow",
  "note": "RingProHero-module__SqReqG__note",
  "poster": "RingProHero-module__SqReqG__poster",
  "section": "RingProHero-module__SqReqG__section",
  "title": "RingProHero-module__SqReqG__title",
  "titleGroup": "RingProHero-module__SqReqG__titleGroup",
});
